module.exports = __webpack_public_path__ + "static/img/aizncz.4e73e99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aizncz.png
// module id = dGWl
// module chunks = 0